// extracted by mini-css-extract-plugin
export var languageSwitcher = "LocaleSwitcher-module--language-switcher--ce6bf";
export var localeOption = "LocaleSwitcher-module--locale-option--90ae3";